export class ContentModel {
  public id: number;
  public label: string;

  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }

  public fromJSONs(jsons) {
    const refs: ContentModel[] = [];
    if (jsons) {
      jsons.forEach(json => {
        refs.push(new ContentModel().fromJSON(json));
      });
    }
    return refs;
  }
}
